import { Group } from 'src/app/models/group';

export class User{

  id:number;
  username:string;
  group:Group;
    
  constructor(object = null){
    if(object){
      this.set(object);
    }
  };

  set(object){
    if(object.id){
      this.id = object.id;
    }
    if(object.username){
      this.username = object.username;
    }
    if(object.group){
      this.group = new Group(object.group);
    }

  }
}
  
  